import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { CTAButton } from './CTAButton';
const tomos = [{
  emoji: '📕',
  number: 'Tomo 1',
  category: 'URGENCIA',
  title: 'Grietas y alivio inmediato',
  desc: 'El protocolo de emergencia para las primeras 48 horas. Qué hacer ahora cuando duele.'
}, {
  emoji: '📗',
  number: 'Tomo 2',
  category: 'BIOMECÁNICA',
  title: 'El agarre perfecto',
  desc: 'La técnica exacta. Los 7 signos del agarre correcto. Cómo corregir toma a toma.'
}, {
  emoji: '📘',
  number: 'Tomo 3',
  category: 'SUMINISTRO',
  title: 'Producción al máximo',
  desc: 'Cómo funciona la producción real. Qué hacer cuando sentís que "se fue la leche".'
}, {
  emoji: '📙',
  number: 'Tomo 4',
  category: 'RESILIENCIA',
  title: 'El mapa de los brotes',
  desc: 'Semana 3, semana 6, mes 3, mes 6. Qué es una huelga y cómo sobrevivir el cluster feeding.'
}, {
  emoji: '📓',
  number: 'Tomo 5',
  category: 'LIBERTAD',
  title: 'Banco de leche y regreso al trabajo',
  desc: 'Sistema completo de extracción. Conservación. Derechos legales — Art. 179 LCT Argentina.'
}, {
  emoji: '📔',
  number: 'Tomo 6',
  category: 'SOBERANÍA',
  title: 'Destete respetuoso',
  desc: 'Los 30 mitos de la lactancia argentina desmontados. El protocolo de destete gradual y de emergencia.'
}];
const includes = ['Protocolos paso a paso listos para aplicar', 'Semáforos de indicadores visuales', 'Plantillas y trackers completables', 'Scripts para responder al entorno', '100% adaptado al contexto argentino'];
export function ProductTomos() {
  return <section className="py-16 md:py-20 px-4 bg-brand-darker relative overflow-hidden" data-id="element-247" data-mp="xepzh97sp544">
      <div className="absolute -left-24 top-24 h-56 w-56 rounded-full border border-brand-primary/15 pointer-events-none" data-id="element-248" data-mp="9pf4y9h1g6yf" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-249" data-mp="4pj0680iobht">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-250" data-mp="uepqr9zo8edb">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-cream-light mb-3" data-id="element-251" data-mp="1394d1wimcp5x">
            📖 Lo que recibís en S.O.S. Lactancia
          </h2>
          <p className="text-xl md:text-2xl text-brand-cream-light/80" data-id="element-252" data-mp="bgwzx62bnuwa">
            6 tomos prácticos + 6 bonos para acompañarte en cada etapa.
          </p>
        </motion.div>

        <div className="text-center mb-8" data-id="element-253" data-mp="kg0jsc9bcebu">
          <h3 className="text-3xl font-bold text-brand-cream inline-flex items-center gap-3" data-id="element-254" data-mp="keyxfbmuk5et">
            <span className="text-4xl" data-id="element-255" data-mp="ph7rkbbghdii">🍼</span> VAS A APRENDER A...
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10" data-id="element-256" data-mp="1vv715ge0lms2">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-cream-light p-7 md:p-8 rounded-3xl border border-brand-cream/40 shadow-lg text-brand-darker" data-id="element-257" data-mp="20syrw72xb2uo" data-mpi={i}>
              <div className="flex items-start gap-4" data-id="element-258" data-mp="32k02bsmh285u">
                <span className="text-5xl shrink-0" data-id="element-259" data-mp="2xmgnaqhy9rcu">{tomo.emoji}</span>
                <div data-id="element-260" data-mp="2snn90vuu9wbm">
                  <div className="flex items-center gap-2 mb-2" data-id="element-261" data-mp="2sp85ir0prpc4">
                    <span className="text-brand-darker font-bold" data-id="element-262" data-mp="2npbysk0mtjsv">
                      {tomo.number}
                    </span>
                    <span className="text-brand-darker/40 text-sm" data-id="element-263" data-mp="qvqy9oghwqhw">—</span>
                    <span className="text-brand-darker/65 text-sm tracking-wider uppercase" data-id="element-264" data-mp="lx7bjlu2vaoh">
                      {tomo.category}
                    </span>
                  </div>
                  <h4 className="text-2xl font-serif text-brand-darker mb-3" data-id="element-265" data-mp="yxhqdtmj9ora">
                    {tomo.title}
                  </h4>
                  <p className="text-brand-darker/75 leading-relaxed" data-id="element-266" data-mp="jz795pbk1txs">
                    {tomo.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-primary/10 border border-brand-primary/30 rounded-2xl p-8 md:p-12 max-w-4xl mx-auto" data-id="element-267" data-mp="b75ds5gcf3ud">
          <h4 className="text-2xl font-serif text-brand-cream-light mb-6 text-center" data-id="element-268" data-mp="3oep3uo1sez1s">
            Cada tomo incluye herramientas listas para usar:
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-269" data-mp="3si50vlhrr1f0">
            {includes.map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-270" data-mp="39tl36o0vuqz2" data-mpi={i}>
                <CheckCircle2 className="w-6 h-6 text-brand-accent shrink-0" data-id="element-271" data-mp="34u86lbk7m5ja" />
                <span className="text-brand-cream text-lg" data-id="element-272" data-mp="3ithmsb8f0zn9">{item}</span>
              </div>)}
          </div>
        </motion.div>

        <CTAButton data-id="element-273" data-mp="3dvg3pqazp0bs" />
      </div>
    </section>;
}